document.addEventListener("theme:loading:end", function (event) {
  var Masonry_item = $(".ProductList__Masonry");

  if (Masonry_item.length) {
    var msnry = new Masonry(".ProductList__Masonry", {
      // options
    });
  }

  // var container = new Ajaxinate({
  //   method: "click",
  //   container: "#AjaxinateLoop",
  //   pagination: "#AjaxinatePagination",
  //   loadingText: "Loading",
  // });
});

(function ($) {
  stickyScrollSettings();

  $(".FeatureText ").css({
    "min-height": $(window).height(),
  });

  $(".Featured__Image ").css({
    height: $(window).height(),
  });

  $(".Header__MainNav .HorizontalList__Item").click(function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $("body").css("overflow", "visible");
    } else {
      $(".Header__MainNav .HorizontalList__Item.active").removeClass("active");
      $(this).addClass("active");
      $("body").css("overflow", "hidden");
    }
  });

  $(".Close__Sidebar__Submenu, .PageOverlay__Sub").click(function () {
    $(".Sidebar__Submenu").removeClass("show");
    $(".PageOverlay__Sub ").removeClass("is-visible");
    $("body").css("overflow", "visible");
  });

  $(".open__shipping").click(function () {
    $(".Shipping__slide").addClass("show__shipping");
    $(".PageOverlay ").addClass("is-visible");
    $("body").css("overflow", "hidden");
  });

  $(".close__shipping, .PageOverlay ").click(function () {
    $(".Shipping__slide").removeClass("show__shipping");
    $(".PageOverlay ").removeClass("is-visible");
    $("body").css("overflow", "visible");
  });

  // Collection tag filter toggle
  $(document).mouseup(function (e) {
    var container = $(".Collapsible__Inner.active");

    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.removeClass("active");
    }
  });

  $(".Collapsible__Button").click(function () {
    var inner = $(this).next(".Collapsible__Inner");

    $(".Collapsible__Inner.active").not(inner).removeClass("active");
    inner.toggleClass("active");
  });

  $(".Artist__Open2").click(function () {
    $(".Artist__Dropdown2").toggleClass("Show__Artist2");

    if ($(".Artist__Dropdown2").css("display") !== "none") {
      $(".CollectionInner__Sidebar").removeClass("is-visible");
    }
  });

  $(".About__Block__Content em").click(function () {
    $(".About__Form").addClass("Show__About__Form");
    $(".PageOverlay ").addClass("is-visible");
    $("body").css("overflow", "hidden");
  });

  $(".About__form__Close, .PageOverlay ").click(function () {
    $(".About__Form").removeClass("Show__About__Form");
    $(".PageOverlay ").removeClass("is-visible");
    $("body").css("overflow", "visible");
  });

  $(".FlexboxIeFix__Info__Open ").click(function () {
    $(".SectionHeader__Description__Slide").addClass("is-visible");
    $(".SectionHeader__Description").addClass("is-hide");
    $(".SectionHeader__Heading").addClass("is-hide");
    $(".FlexboxIeFix__Info__Open").addClass("is-hide");
  });

  $(".FlexboxIeFix__Info__close ").click(function () {
    $(".SectionHeader__Description__Slide").removeClass("is-visible");
    $(".SectionHeader__Description").removeClass("is-hide");
    $(".SectionHeader__Heading").removeClass("is-hide");
    $(".FlexboxIeFix__Info__Open").removeClass("is-hide");
  });

  $(".Collection__All").click(function () {
    $(".CollectionInner__Sidebar").toggleClass("is-visible");

    if ($(".CollectionInner__Sidebar").css("display") !== "none") {
      $(".Artist__Dropdown").removeClass("Show__Artist");
    }
  });

  $(".CollectionInner__Sidebar").click(function () {
    $(".CollectionInner__Sidebar").removeClass("is-visible");
  });

  $(".Search__Input").blur(function (event) {
    var inputValue = this.value;
    if (inputValue) {
      this.classList.add("value-exists");
    } else {
      this.classList.remove("value-exists");
    }
  });

  $(".Collection__Artist__Filter").click(function () {
    $(".CollectionInner__Sidebar").toggleClass("is-visible");
  });

  AOS.init({
    duration: 1200,
    once: true,
  });

  // document.addEventListener("DOMContentLoaded", function () {
  //   var container = new Ajaxinate({
  //     method: "click",
  //     container: "#AjaxinateLoop",
  //     pagination: "#AjaxinatePagination",
  //     loadingText: "Loading",
  //   });
  // });

  $(".FlexboxIeFix__Image, .Article__Imageslider").slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  });

  var Masonry_item = $(".ProductList__Masonry");

  if (Masonry_item.length) {
    var msnry = new Masonry(".ProductList__Masonry", {
      // options
      horizontalOrder: true,
    });
  }

  $(window).on("load", function () {
    var maxTimeChecker = 2000;
    var timeChecker = 0;
    var HaveInfiniteOption = $("#infiniteoptions-container").length
      ? true
      : false;

    var CheckShoppad = setInterval(() => {
      timeChecker = timeChecker + 500;

      if (timeChecker == maxTimeChecker) clearInterval(CheckShoppad);

      if (window.Shoppad && window.Shoppad.apps.infiniteoptions._initialized) {
        $(document).on("click", ".spb-label-tooltip", function (e) {
          $(this)
            .next()
            .slideToggle(function () {
              if ($(this).is(":visible")) $(this).css("display", "block");
            });
          $(this).toggleClass("active");
          /*
                    $(this).find('label').removeClass("active");


                    $(this).find('input[checked="checked"]').parent().addClass("active"); */
        });
        $(document).on("click", ".spb-productoptiontextcolor", function (e) {
          var $self = $(this);
          if ($self.is(":checked")) {
            $self.parent().addClass("Frame--Active");
            $self.parent().siblings().removeClass("Frame--Active");
          }
        });

        $(".spb-productoptiontextcolor").each(function () {
          var $self = $(this);
          if ($self.is(":checked")) {
            $self.parent().addClass("Frame--Active");
          }
        });

        clearInterval(CheckShoppad);

        $('form[action$="/cart/add"]').on("submit", function (e) {
          e.preventDefault();
          var form = $(this),
            addToCartBtn = form.find(".ProductForm__AddToCart"),
            addToCartBtn_label = addToCartBtn.first("span").text(),
            btnAdding = "Adding...",
            btnAdded = "Product added!";

          console.log($(this).serialize());

          addToCartBtn.first("span").text(btnAdding);

          jQuery
            .post(
              "/cart/add.js",
              form.serialize(),
              function (a) {
                console.log(a);

                addToCartBtn.first("span").text(btnAdded);

                document.documentElement.dispatchEvent(
                  new CustomEvent("cart:refresh", {
                    bubbles: true,
                  })
                );
                //$('form[action$="/cart/add"]').on('submit', function(e){e.preventDefault()});

                setTimeout(() => {
                  addToCartBtn.first("span").text(addToCartBtn_label);

                  $(".Cart--trigger")
                    .click(function () {
                      // 'this' is not a jQuery object, so it will use
                      // the default click() function
                      this.click();
                    })
                    .click();

                  e.preventDefault();
                }, 1000);
              },
              "json"
            )
            .done(function (a) {
              //alert( "second success", a );
            })
            .fail(function (a) {
              addToCartBtn.first("span").text("Product already in your cart!");

              setTimeout(() => {
                addToCartBtn.first("span").text(addToCartBtn_label);
              }, 1000);
            })
            .always(function (a) {
              //alert( "finished", a );
            });
        });

        // Perfo;
      }
    }, 500);
  });
})(jQuery);

// function masonrys(){

//     var macyInstance  = new Macy({
//         container: '.ProductList__Item',
//         trueOrder: false,
//         waitForImages: false,
//         useOwnImageLoader: false,
//         debug: false,
//         mobileFirst: true,
//         columns: 1,

//         breakAt: {
//             1008: 4,
//             642: 3,
//             320: 2
//         },
//     });

// }

function stickyScrollSettings() {
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
      $(".Header").addClass("Fixheader");
    } else {
      $(".Header").removeClass("Fixheader");
    }
  });
}

$(".but").click(function () {
  // Close all open windows
  $(".content").stop().slideUp(300);
  // Toggle this window open/close
  $(this).next(".content").stop().slideToggle(300);
  //hitter test//
  $(".hitter").show();
});

$(".but").click(function () {
  $(this).toggleClass("active");
});

document.getElementById("Price") &&
  document.getElementById("Price").addEventListener("click", function () {
    this.classList.toggle("active");
  });
